import React, { useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { UserEditDialogHeader } from './UserEditDialogHeader';
import { useUserUIContext } from '../UserUIContext';
import * as actions from '../../../_redux/user/userAction';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { UserEditForm } from './UserEditForm';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../_metronic/_helpers';

function UserEditDialog({ id, show, onHide }) {

    // User UI Context
    const userUIContext = useUserUIContext();
    const userUIProps = useMemo(() => {
        return {
            initUser: userUIContext.initUser,
            queryParams: userUIContext.queryParams,
            setQueryParams: userUIContext.setQueryParams,
        };
    }, [userUIContext]);

    // User Redux state
    const dispatch = useDispatch();
    const { actionsLoading, userForEdit, error } = useSelector(
        (state) => ({
            actionsLoading: state.users.actionsLoading,
            userForEdit: state.users.userForEdit,
            error: state.users.error
        }),
        shallowEqual,
    );
    if (error) {
        toast.error(error, toastOption)
    }


    useEffect(() => {
        // server call for getting User by id
        dispatch(actions.fetchUser(id));
    }, [id, dispatch]);

    const saveUser = (user) => {

        // Sanitation Data
        let newValue;
        if (user.change_pass === undefined) {
            newValue = { ...user, password: '' };
        } else {
            newValue = { ...user };
        }

        if (!id) {
            dispatch(actions.createUser(newValue)).then((response) => {
                toast.success(response.message, toastOption);
                dispatch(actions.fetchUsers(userUIProps.queryParams)).then(() => onHide());
            });
        } else {
            dispatch(actions.updateUser(newValue)).then((response) => {
                toast.success(response.message, toastOption);
                dispatch(actions.fetchUsers(userUIProps.queryParams)).then(() => onHide());
            });
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="modal-sizes-title-lg"
        >
            <UserEditDialogHeader id={id} />

            <UserEditForm
                saveUser={saveUser}
                actionsLoading={actionsLoading}
                user={userForEdit || userUIProps.initUser}
                onHide={onHide}
            />
        </Modal>
    );
}

export default UserEditDialog;
